export class Token {
  public id: number;
  public username: string = '';
  public token: string = '';
  public roles: Array<string> = [];
  public squads: Array<number> = [];
  public approved: boolean;
}
